import { render, staticRenderFns } from "./SkewBand.vue?vue&type=template&id=7632e2fc&scoped=true&"
import script from "./SkewBand.vue?vue&type=script&lang=ts&"
export * from "./SkewBand.vue?vue&type=script&lang=ts&"
import style0 from "./SkewBand.vue?vue&type=style&index=0&id=7632e2fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7632e2fc",
  null
  
)

export default component.exports